import { render, staticRenderFns } from "./AddNewChoirStepTwo.vue?vue&type=template&id=b3385090&scoped=true&"
import script from "./AddNewChoirStepTwo.vue?vue&type=script&lang=ts&"
export * from "./AddNewChoirStepTwo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3385090",
  null
  
)

export default component.exports